import React, { useState } from 'react'
import TableLoader from '../../common/TableLoader'
import PageHeader from '../../shared/PageHeader'
import { useTranslation } from 'react-i18next'
import PolicyLevelTable from './PolicyLevelTable'

function NprPolicyLevel () {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  return (
    <div>
      {loading ? (
        <TableLoader />
      ) : (
        <div className='superGit_container !p-0'>
          <PageHeader
            title={t('Policy Level')}
            subtitle
            total={0}
            entriesLabel={t('Entries')}
          >
            {/* <CustomButton
                  label={t('Add New Payer')}
                  icon={<AddIcon />}
                  onClick={() => {
                    navigate('/payer-managment/form')
                  }}
                /> */}
          </PageHeader>
          <div className='mt-3'>
            <PolicyLevelTable />
          </div>
        </div>
      )}
    </div>
  )
}

export default NprPolicyLevel
